import { BsModalRef } from 'ngx-bootstrap/modal';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { ProjectService } from 'src/app/services/project.service';
import { UtilsService } from 'src/app/services/utils.service';

export enum ConfigurationType{
  facility = "facility",
  defaultAltitudes = "defaultAltitudes",
  directories = "directories",
  procedure = "procedure"
}



export class ConfigurationField  {

  configurationController : ConfigurationService;

  constructor(configurationController : ConfigurationService,
    private utilsService: UtilsService,
    public configurationType: ConfigurationType
    ) {
      this.configurationController = configurationController;
    }


  updateLengthField(unit:String,unitFirstField:String ,fieldName:string, value:number){
      switch(unit){
        case "M":
          switch(unitFirstField){
            case "FT": this.configurationController.currentConfiguration[this.configurationType][fieldName+unit] = this.utilsService.feetToMeters(value);
            case "NM":  this.configurationController.currentConfiguration[this.configurationType][fieldName+unit] = this.utilsService.nmToMeters(value);
          }
          this.configurationController.currentConfiguration[this.configurationType][fieldName] = value;
          break;
        case "FT":
          this.configurationController.currentConfiguration[this.configurationType][fieldName+unit] = this.utilsService.metersToFeet(value);
          this.configurationController.currentConfiguration[this.configurationType][fieldName] = this.utilsService.metersToFeet(value);
          break;
        case "NM":
          this.configurationController.currentConfiguration[this.configurationType][fieldName+unit] = this.utilsService.metersToNm(value);
          this.configurationController.currentConfiguration[this.configurationType][fieldName+unit] = this.utilsService.metersToNm(value);
          break;
      }
    }

  updateField(fieldName: any, value:any){
    this.configurationController.currentConfiguration[this.configurationType][fieldName] = value;
  }
}







